export const initial = {
  typ: null,
  beschreibung: null,
  jahr: null,
  datum: null,
  bearbeiter: null,
  bemerkungen: null,
  planVorhanden: null,
  planBezeichnung: null,
  flaeche: null,
  markierung: null,
  anzTriebe: null,
  anzPflanzen: null,
  anzPflanzstellen: null,
  wirtspflanze: null,
  herkunftPop: null,
  sammeldatum: null,
  vonAnzahlIndividuen: null,
  form: null,
  pflanzanordnung: null,
}

export const simpleTypes = {
  typ: 'number',
  beschreibung: 'string',
  jahr: 'number',
  datum: 'date',
  bearbeiter: 'uuid',
  bemerkungen: 'string',
  planVorhanden: 'number',
  planBezeichnung: 'string',
  flaeche: 'number',
  markierung: 'string',
  anzTriebe: 'number',
  anzPflanzen: 'number',
  anzPflanzstellen: 'number',
  wirtspflanze: 'string',
  herkunftPop: 'string',
  sammeldatum: 'string',
  vonAnzahlIndividuen: 'number',
  form: 'string',
  pflanzanordnung: 'string',
}
